import React, { FC, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/Header/Header';
import LeftDrawer from '../LeftDrawer/LeftDrawer';
import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/dist/sweetalert2.css';
import { ToastContainer } from 'react-toastify';
import { useApplicationStore } from '../../stores/applicationStore';
import { useUserStore } from '../../stores/userStore';

interface LayoutProps {}

const Layout: FC<LayoutProps> = () => {
    const [isToggled, setIsToggled] = useState(true); // Varsayılan olarak true
    const applicatonStore = useApplicationStore();
    const userStore = useUserStore();

    const handleToggle = () => {
        setIsToggled(!isToggled);
    };

    useEffect(() => {
        applicatonStore.fetch();
        userStore.fetch();
    }, []);

    return (
        <>
            <ToastContainer />
            <Header onToggle={handleToggle} />
            {/* LeftDrawer'a isSidebarVisible prop'unu gönderiyoruz */}
            <LeftDrawer isSidebarVisible={isToggled} />
            <section className={`wrapper ${isToggled ? 'toggle' : ''}`}>
                <Outlet />
            </section>
        </>
    );
};

export default Layout;
